(function () {
  'use strict';

  class PriceRange extends HTMLElement {
    connectedCallback() {
      this.minSlider = this.querySelector('[data-range-min]');
      this.maxSlider = this.querySelector('[data-range-max]');
      this.minInput = this.querySelector('[data-price-min]');
      this.maxInput = this.querySelector('[data-price-max]');
      if (!this.minSlider || !this.maxSlider) return;
      this.update();
      this.minSlider.addEventListener('input', this.onSlide.bind(this, 'min'));
      this.maxSlider.addEventListener('input', this.onSlide.bind(this, 'max'));
      this.minSlider.addEventListener('change', this.commit.bind(this, this.minInput));
      this.maxSlider.addEventListener('change', this.commit.bind(this, this.maxInput));
      this.minInput.addEventListener('input', this.onType.bind(this));
      this.maxInput.addEventListener('input', this.onType.bind(this));
    }

    onSlide(which) {
      var min = Number(this.minSlider.value);
      var max = Number(this.maxSlider.value);
      if (min > max) {
        if (which === 'min') this.minSlider.value = max;
        else this.maxSlider.value = min;
      }
      this.minInput.value = Number(this.minSlider.value) > 0 ? this.minSlider.value : '';
      this.maxInput.value = Number(this.maxSlider.value) < Number(this.getAttribute('data-max')) ? this.maxSlider.value : '';
      this.update();
    }

    onType() {
      this.minSlider.value = this.minInput.value || 0;
      this.maxSlider.value = this.maxInput.value || this.getAttribute('data-max');
      this.update();
    }

    commit(input) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    update() {
      var max = Number(this.getAttribute('data-max')) || 1;
      this.style.setProperty('--range-start', (Number(this.minSlider.value) / max) * 100 + '%');
      this.style.setProperty('--range-end', (Number(this.maxSlider.value) / max) * 100 + '%');
    }
  }

  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

  var sortUid = 0;

  class SortSelect extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      this.select = this.querySelector('select');
      if (!this.select) return;
      sortUid += 1;
      var listId = 'SortList-' + sortUid;

      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'sort-select__button';
      this.button.setAttribute('aria-haspopup', 'listbox');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-controls', listId);
      var label = document.querySelector('label[for="' + this.select.id + '"]');
      this.labelText = label ? label.textContent.trim() : '';
      this.buttonText = document.createElement('span');
      this.button.appendChild(this.buttonText);
      this.button.insertAdjacentHTML(
        'beforeend',
        '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );

      this.list = document.createElement('ul');
      this.list.id = listId;
      this.list.className = 'sort-select__list';
      this.list.setAttribute('role', 'listbox');
      this.list.tabIndex = -1;
      if (this.labelText) this.list.setAttribute('aria-label', this.labelText);
      this.list.hidden = true;

      Array.prototype.forEach.call(this.select.options, function (option, i) {
        var item = document.createElement('li');
        item.id = listId + '-' + i;
        item.className = 'sort-select__option';
        item.setAttribute('role', 'option');
        item.setAttribute('data-value', option.value);
        item.textContent = option.textContent;
        this.list.appendChild(item);
      }, this);

      this.select.tabIndex = -1;
      this.select.setAttribute('aria-hidden', 'true');
      this.classList.add('is-enhanced');
      this.append(this.button, this.list);
      this.sync();

      this.button.addEventListener('click', this.toggle.bind(this));
      this.button.addEventListener('keydown', this.onButtonKey.bind(this));
      this.list.addEventListener('keydown', this.onListKey.bind(this));
      this.list.addEventListener('click', this.onListClick.bind(this));
      this.onOutside = this.onOutside.bind(this);
      this.select.addEventListener('change', this.sync.bind(this));
    }

    sync() {
      var current = this.select.options[this.select.selectedIndex];
      this.buttonText.textContent = current ? current.textContent : '';
      this.button.setAttribute('aria-label', this.labelText + (current ? ': ' + current.textContent : ''));
      this.items().forEach(function (item) {
        item.setAttribute('aria-selected', item.getAttribute('data-value') === this.select.value ? 'true' : 'false');
      }, this);
    }

    items() {
      return Array.prototype.slice.call(this.list.children);
    }

    open() {
      this.list.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      this.focusIndex(Math.max(this.select.selectedIndex, 0));
      this.list.focus();
      document.addEventListener('click', this.onOutside);
    }

    close(returnFocus) {
      this.list.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      this.list.removeAttribute('aria-activedescendant');
      document.removeEventListener('click', this.onOutside);
      if (returnFocus) this.button.focus();
    }

    toggle() {
      if (this.list.hidden) this.open();
      else this.close(true);
    }

    focusIndex(index) {
      var items = this.items();
      if (!items.length) return;
      index = Math.max(0, Math.min(index, items.length - 1));
      this.activeIndex = index;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
      this.list.setAttribute('aria-activedescendant', items[index].id);
      items[index].scrollIntoView({ block: 'nearest' });
    }

    choose(index) {
      var item = this.items()[index];
      if (!item) return;
      var changed = this.select.value !== item.getAttribute('data-value');
      this.select.value = item.getAttribute('data-value');
      this.close(true);
      if (changed) this.select.dispatchEvent(new Event('change', { bubbles: true }));
      else this.sync();
    }

    onButtonKey(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.open();
      }
    }

    onListKey(event) {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          this.focusIndex(this.activeIndex + 1);
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.focusIndex(this.activeIndex - 1);
          break;
        case 'Home':
          event.preventDefault();
          this.focusIndex(0);
          break;
        case 'End':
          event.preventDefault();
          this.focusIndex(this.items().length - 1);
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.choose(this.activeIndex);
          break;
        case 'Escape':
          event.preventDefault();
          event.stopPropagation();
          this.close(true);
          break;
        case 'Tab':
          this.close(false);
          break;
        default:
          break;
      }
    }

    onListClick(event) {
      var item = event.target.closest('[role="option"]');
      if (item) this.choose(this.items().indexOf(item));
    }

    onOutside(event) {
      if (!this.contains(event.target)) this.close(false);
    }
  }

  if (!customElements.get('sort-select')) customElements.define('sort-select', SortSelect);

  var root = document.querySelector('[data-collection]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var controller = null;
  var timer = null;

  function currentForm() {
    return document.getElementById('FacetsForm-sidebar');
  }

  function buildUrl() {
    var form = currentForm();
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (typeof value === 'string' && value !== '') params.append(key, value);
      });
    }
    params.delete('page');
    var query = params.toString();
    return window.location.pathname + (query ? '?' + query : '');
  }

  function setStatus(text) {
    var status = document.querySelector('[data-collection-status]');
    if (status) status.textContent = text || '';
  }

  function syncFacetInputs(fresh) {
    document.querySelectorAll('[data-facets-form] input[id]').forEach(function (input) {
      var match = fresh.querySelector('[data-facets-form] input[id="' + input.id + '"]');
      if (!match) return;
      input.disabled = match.disabled;
      var label = input.closest('label');
      var freshLabel = match.closest('label');
      if (label && freshLabel) {
        label.classList.toggle('is-disabled', freshLabel.classList.contains('is-disabled'));
        var count = label.querySelector('[data-facet-count]');
        var freshCount = freshLabel.querySelector('[data-facet-count]');
        if (count && freshCount) count.textContent = freshCount.textContent;
      }
    });
  }

  function render(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var results = document.querySelector('[data-collection-results]');
    var freshResults = doc.querySelector('[data-collection-results]');
    if (results && freshResults) {
      results.replaceWith(freshResults);
      if (window.byju && window.byju.observeReveal) window.byju.observeReveal(freshResults);
      if (window.byju && window.byju.wishlist) window.byju.wishlist.sync();
    }

    var count = document.querySelector('[data-collection-count]');
    var freshCount = doc.querySelector('[data-collection-count]');
    if (count && freshCount) count.textContent = freshCount.textContent;

    var filterButton = document.querySelector('.listing__filter-btn');
    var freshButton = doc.querySelector('.listing__filter-btn');
    if (filterButton && freshButton) filterButton.replaceChildren.apply(filterButton, Array.prototype.slice.call(freshButton.childNodes));

    var drawerBody = document.querySelector('.filter-drawer .drawer__body');
    var freshDrawerBody = doc.querySelector('.filter-drawer .drawer__body');
    if (drawerBody && freshDrawerBody) drawerBody.replaceWith(freshDrawerBody);
    var drawerFooter = document.querySelector('.filter-drawer .drawer__footer');
    var freshDrawerFooter = doc.querySelector('.filter-drawer .drawer__footer');
    if (drawerFooter && freshDrawerFooter) drawerFooter.replaceWith(freshDrawerFooter);

    syncFacetInputs(doc);
    setStatus(freshCount ? freshCount.textContent : '');
  }

  function update(url, push) {
    if (controller) controller.abort();
    controller = new AbortController();
    var current = controller;
    var results = document.querySelector('[data-collection-results]');
    if (results) results.setAttribute('aria-busy', 'true');
    setStatus(root.getAttribute('data-updating-text'));

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl, { signal: current.signal })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then(function (html) {
        if (current !== controller) return;
        render(html);
        if (push) window.history.pushState({ facets: true }, '', url);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        window.location.href = url;
      })
      .finally(function () {
        var live = document.querySelector('[data-collection-results]');
        if (live) live.removeAttribute('aria-busy');
      });
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      update(buildUrl(), true);
    }, delay);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLElement)) return;
    var inSidebar = target.closest('#FacetsForm-sidebar');
    var isSort = target.matches('[data-facet-sort]');
    if (!inSidebar && !isSort) return;
    schedule(target.matches('input[type="number"]') ? 500 : 0);
  });

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.id === 'FacetsForm-sidebar') {
      event.preventDefault();
      schedule(0);
    }
  });

  window.addEventListener('popstate', function () {
    update(window.location.pathname + window.location.search, false);
  });
})();
